const getTicketsLink = (tickets) => {
    return tickets && tickets[0] && tickets[0].ticketLinks && tickets[0].ticketLinks.home;
};

export default getTicketsLink;
